'use strict';var _dec,_desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const Group=require('../../../../../dist-es6/shared/domain/group');
const ex=require('pulsar-utils/dist-es6/ex');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const{MinDeviationThreshold,MaxDeviationThreshold,MinFatigueThreshold,MaxFatigueThreshold}=require('../../../../../dist-es6/shared/domain/group');let

SetThresholdModalController=(_dec=






























































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=class SetThresholdModalController extends BaseController{static get $inject(){return['$modalInstance','$scope','$timeout','socketService','organizationDefaultsService','uncaughtErrorHandler','uiCommandFactory','resolvedParameters']}constructor($modalInstance,$scope,$timeout,socketService,organizationDefaultsService,uncaughtErrorHandler,uiCommandFactory,resolvedParameters){super(uncaughtErrorHandler);this._$modalInstance=$modalInstance;this._$scope=$scope;this._$timeout=$timeout;this._onThresholdSet=resolvedParameters.onThresholdSet;this._group=resolvedParameters.group;this._fatigueThreshold=ex(this._group.fatigueThreshold).otherwise(resolvedParameters.defaultFatigueThreshold);this._deviationThreshold=ex(this._group.deviationThreshold).otherwise(resolvedParameters.defaultDeviationThreshold);this._socketService=socketService;this._setOrganizationThresholdsCommand=(f,d)=>organizationDefaultsService.setOrganizationThresholds(f,d);this.setThresholdCommand=uiCommandFactory.makeForModal($modalInstance,()=>this._setThreshold());this.selectedDeviationThreshold=this._deviationThreshold;this.availableDeviationThresholds=_.range(MinDeviationThreshold,MaxDeviationThreshold+1);this._$scope.$watch('controller.selectedDeviationThreshold',newDeviationThreshold=>{if(newDeviationThreshold===this._deviationThreshold){return}this._deviationThreshold=newDeviationThreshold})}get isOrganization(){return this._group.isSpecialGroupContainingWholeOrg===!0||this._group.id.toString()===Group.FakeWholeOrgGroupId}get fatigueThreshold(){return this._fatigueThreshold}set fatigueThreshold(fatigueThreshold){this._fatigueThreshold=fatigueThreshold}get deviationThreshold(){return this._deviationThreshold}set deviationThreshold(deviationThreshold){this._deviationThreshold=deviationThreshold}
async _setThreshold(){
if(this.isOrganization){
await this._setOrganizationThresholdsCommand(this._fatigueThreshold,this._deviationThreshold);
}else{
await this._socketService.sendAndWaitForResponse('SetGroupThresholds',{
groupId:this._group.id,
fatigueThreshold:this._fatigueThreshold,
deviationThreshold:this._deviationThreshold});

}

await this._onThresholdSet(this._group.id);

return ModalSubmissionResult.Close();
}

onCancel(){
this._$modalInstance.dismiss();
}},(_applyDecoratedDescriptor(_class.prototype,'_setThreshold',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_setThreshold'),_class.prototype)),_class));


module.exports=SetThresholdModalController;
//# sourceMappingURL=setThresholdModalController.js.map
